import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RepeatDirective } from '../../directives/repeat.directive';
import { ShimmerDirective } from '../../directives/shimmer.directive';

@Component({
  selector: 'lib-credit-bar',
  imports: [RepeatDirective, ShimmerDirective],
  templateUrl: './credit-bar.component.html',
  styleUrl: './credit-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreditBarComponent {
  completedCount = input.required<number>();
  maxCount = input.required<number>();
  isLoading = input<boolean>(false);
}
